import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { entrySlice } from './EntryStore';
import { promotionSlice } from './PromotionStore';
import { animationSlice } from './AnimationStore';
import { loadingSlice } from './LoadingStore';

export const defaultDrawTicketState = {
    gameOver: false,
    success: false,
    message: '',
};

// REDUCERS
// basic actions that affect this object only

const enterDrawTicketReducer = (state, action) => {
    if (action.payload.success) {
        return {
            ...state,
            success: action.payload.success,
            message: "Your entry has been accepted and added to the 'My Entries' page.",
        };
    } else {
        return {
            ...state,
            success: action.payload.success,
            message: action.payload.message,
        };
    }
};

const resetReducer = (state, action) => {
    return {
        ...defaultDrawTicketState,
    };
};

const setGameOverReducer = (state, action) => {
    return {
        ...state,
        gameOver: action.payload.gameOver,
    };
};

export const drawTicketSlice = createSlice({
    name: 'drawTicket',
    initialState: defaultDrawTicketState,
    reducers: {
        enterDrawTicket: enterDrawTicketReducer,
        reset: resetReducer,
        setGameOver: setGameOverReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const enterDrawTicket = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'enterDrawTicket' }));
    const result = await apiClient.enterDrawTicket(payload);
    if (result.success) {

        // IGR reveal animation related functionality
        if (result?.gameUrl?.game) {
            // Setting animated reveal
            dispatch(
                animationSlice.actions.setAnimation({
                    animation: result?.entry?.points,
                    gameUrl: result?.gameUrl,
                })
            );

            // Report for Interactive Game Stats
            await apiClient.setEntryFlashGameFlag({
                game_id: result?.entry?.game_id ?? '',
                entry_id: result?.entry?.id ?? '',
                flag: 1, // 1 = Game played (default), 0 = No game played, 2 = Game skipped
            });
        }

        dispatch(entrySlice.actions.reset());
        dispatch(promotionSlice.actions.reset());
        dispatch(entrySlice.actions.setLastEntry(result.entry));
    }
    dispatch(drawTicketSlice.actions.enterDrawTicket(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'enterDrawTicket' }));
};

const setGameOver = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'setGameOver' }));
    const result = await apiClient.getGameOver(payload);
    dispatch(drawTicketSlice.actions.setGameOver(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'setGameOver' }));
};

//actions that get exported to the views
export const drawTicketActions = (dispatch) => {
    return {
        enterDrawTicket: (payload) => enterDrawTicket(dispatch, payload),
        reset: (payload) => dispatch(drawTicketSlice.actions.reset()),
        setGameOver: (payload) => setGameOver(dispatch, payload),
    };
};
